import { Api } from '../../services/api';

import { useRef, useState } from 'react';

export const CargaModal = () => {
  //eslint-disable-next-line
  const [numero, setNumero] = useState('');
  const [descricao, setDescricao] = useState('');

  const inputNF = useRef(null);

  const [nfs, setNFs] = useState([]);

  const [reqId, setReqId] = useState(null);

  const createCarga = async () => {
    try {
      const carga = await Api.post('/carga/create', {
        numero,
        descricao,
        idStatus: '2',
      });

      for (let nf of nfs) {
        console.log(nf);
        await Api.post('/canhoto/create', {
          nf,
          idCarga: '' + carga.data.id,
        });
      }

      setReqId(carga.data.id);
    } catch (e) {
      console.log('Deu ruim');
    }
  };

  const handleClick = () => {
    createCarga();
  };

  return (
    <div>
      <div>
        <div className="form-floating mb-3">
          <input
            type="number"
            className="form-control"
            id="floatingInput"
            autoComplete="false"
            onChange={(e) => setNumero(e.target.value)}
            value={numero}
          />
          <label htmlFor="floatingInput">Número da carga no SAP</label>
        </div>
        <div className="form-floating mb-3">
          <input
            type="text"
            className="form-control"
            id="floatingPassword"
            autoComplete="false"
            onChange={(e) => setDescricao(e.target.value)}
            value={descricao}
          />
          <label htmlFor="floatingPassword">Descrição</label>
        </div>
        <div className="input-group mb-3">
          <input
            type="number"
            className="form-control"
            placeholder="Insira o número da Nota Fiscal"
            aria-label="Nota Fiscal"
            aria-describedby="button-addon2"
            ref={inputNF}
          />
          <button
            className="btn btn-outline-secondary"
            type="button"
            id="button-addon2"
            onClick={() => {
              const newArray = [...nfs, inputNF.current.value];
              setNFs(newArray);
              inputNF.current.value = '';
            }}
          >
            Adicionar
          </button>
        </div>
        <div className="row mb-4">
          <div className="col" style={{ margin: 'auto' }}>
            {nfs.length > 0 ? (
              <ul className="list-group list-group-flush">
                {nfs.map((v) => (
                  <li key={v} className="list-group-item">
                    {v}
                  </li>
                ))}
              </ul>
            ) : (
              <span>Nenhum Nota Fiscal foi inserida</span>
            )}
          </div>
        </div>

        <div className="row">
          <div className="col" style={{ textAlign: 'center', margin: 'auto' }}>
            <span>Sucesso na criação da carga de acesso com ID: {reqId}</span>
          </div>
          <div className="col">
            <button className="btn btn-success" style={{ float: 'right' }} onClick={handleClick}>
              Montar carga
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
